import React, { Component } from "react";
import 'styled-components/macro'

export default class BackgroundImage extends Component {
  render() {
    const { imgSrc, width, height } = this.props
    return (
      <div css={`
        width: ${width}px;
        height: ${height}px;
        background-image: url(${imgSrc});
        background-size: ${width}px ${height}px;
        background-repeat: no-repeat;
        -webkit-touch-callout:none;
        -webkit-user-select:none;
        -khtml-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
        user-select:none;
        -webkit-tap-highlight-color:rgba(0,0,0,0);
        :focus {
          outline: none;
          box-shadow: none;
        }
      `} />
    )
  }
}